var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock"},[_c('span',{staticClass:"time",style:([_vm.$vuetify.breakpoint.xs ? {'font-size': '10pt'} : {'font-size': '13pt'}])},[_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }